/* ============================================================================
   OLBIY GECE AGACI — Shopify section script
   Landing script.js + enhance.js'in Shopify'a uyarlanmış hali.
   ÇIKARILDI: kendi navbar/mobil menü/footer/legal modal/stoktv iframe formu.
   EKLENDİ  : Shopify sepet + paket modalı.
   Veriler: window.OGA26 (section schema'dan gelir)
   ============================================================================ */
(function () {
  'use strict';

  var CFG = window.OGA26 || {};
  var root = document.querySelector('.oga26');
  if (!root) return;

  /* ---------------- scroll reveal ---------------- */
  function reveal() {
    var items = root.querySelectorAll('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- SSS ---------------- */
  function faq() {
    root.querySelectorAll('.faq-list details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        root.querySelectorAll('.faq-list details').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---------------- yumuşak kaydırma (tema başlığı için pay) ---------------- */
  function smooth() {
    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href');
        if (!href || href === '#') return;
        var t = root.querySelector(href);
        if (!t) return;
        e.preventDefault();
        var top = t.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* ---------------- sabit alt bar + WhatsApp ---------------- */
  function floats() {
    var bar = root.querySelector('.floating-order');
    var wa = root.querySelector('.wa-float');
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (bar) bar.classList.toggle('show', y > 620);
      if (wa) wa.classList.toggle('show', y > 600);
    }, { passive: true });
  }

  /* ---------------- paket seçimi ---------------- */
  var selected = null;

  function pick(card) {
    if (!card || card.classList.contains('pkg-out')) return;
    selected = card;
    var vid = card.getAttribute('data-vid');
    root.querySelectorAll('.pkg-card').forEach(function (c) {
      c.classList.toggle('sel', c.getAttribute('data-vid') === vid);
    });
    var hid = root.querySelector('#oga26VariantId');
    if (hid) hid.value = vid;

    var price = card.getAttribute('data-price');
    var total = card.getAttribute('data-total');
    var unit = card.getAttribute('data-unit');
    var qty = card.getAttribute('data-qty');
    var free = card.getAttribute('data-free') === '1';
    var save = card.getAttribute('data-save');

    root.querySelectorAll('[data-pkg-total]').forEach(function (e) { e.textContent = total; });
    root.querySelectorAll('[data-price-now],[data-hero-price]').forEach(function (e) { e.textContent = price; });
    root.querySelectorAll('[data-hero-note]').forEach(function (e) { e.textContent = qty + ' adet · adet başı ' + unit; });
    root.querySelectorAll('.ho-ship').forEach(function (e) { e.textContent = free ? '🚚 Kargo bedava' : 'Kargo eklenir'; });
    root.querySelectorAll('[data-bar-price]').forEach(function (e) { e.textContent = qty + ' Adet · ' + total; });
    root.querySelectorAll('[data-bar-note]').forEach(function (e) {
      e.textContent = (free ? 'Kargo bedava' : 'Kapıda ödeme') + (save ? ' • ' + save + ' kazanç' : '');
    });
    root.querySelectorAll('[data-price-note]').forEach(function (e) {
      e.innerHTML = qty + ' adet · adet başı <b>' + unit + '</b>' + (free ? ' · <b>kargo bedava</b>' : '') +
        (save ? ' · <b>' + save + ' kazanç</b>' : '');
    });
  }

  function packages() {
    var cards = root.querySelectorAll('.pkg-card');
    if (!cards.length) return;
    cards.forEach(function (c) { c.addEventListener('click', function () { pick(c); }); });
    pick(root.querySelector('.pkg-card.sel') || cards[0]);
  }

  /* ---------------- modal ---------------- */
  function modal() {
    var m = root.querySelector('#oga26Modal');
    if (!m) return;
    function open(e) {
      if (e) e.preventDefault();
      m.classList.add('open'); m.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      m.classList.remove('open'); m.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    root.querySelectorAll('.js-order').forEach(function (b) { b.addEventListener('click', open); });
    m.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', close); });
    m.addEventListener('click', function (e) { if (e.target === m) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ============================================================================
     DOĞRUDAN ÖDEMEYE GEÇ
     Tema (Digimoli) sepet drawer'ı için fetch/submit olaylarını dinliyor.
     Bu yüzden:
       1) sepeti temizle  (sadece seçilen paket gitsin, çift tıkta birikmesin)
       2) NATIVE form POST -> /cart/add  +  return_to=/checkout
          HTMLFormElement.prototype.submit.call() submit OLAYI TETİKLEMEZ
          => tema JS'i araya giremez, Shopify sunucu tarafında ekleyip
             doğrudan ödemeye yönlendirir.
     ============================================================================ */
  function checkoutWith(vid, btn) {
    if (!vid) return;
    var addUrl = (CFG.cartAddUrl || '/cart/add');
    var clearUrl = (CFG.cartClearUrl || '/cart/clear') + '.js';
    var old = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Ödemeye yönlendiriliyorsunuz...'; }

    function go() {
      var f = document.createElement('form');
      f.method = 'post';
      f.action = addUrl;
      f.style.display = 'none';
      [['id', String(vid)], ['quantity', '1'], ['return_to', '/checkout']].forEach(function (kv) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = kv[0]; i.value = kv[1];
        f.appendChild(i);
      });
      document.body.appendChild(f);
      HTMLFormElement.prototype.submit.call(f);   // olay dinleyicilerini atlar
    }

    var done = false;
    function once() { if (!done) { done = true; go(); } }
    setTimeout(once, 1200);                       // temizleme takılırsa yine de git
    fetch(clearUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(once).catch(once);
    if (btn) setTimeout(function () { btn.disabled = false; btn.innerHTML = old; }, 8000);
  }

  function buy() {
    root.querySelectorAll('.oga26-buy').forEach(function (b) {
      b.addEventListener('click', function () {
        var vid = selected ? selected.getAttribute('data-vid') : null;
        if (!vid) { var h = root.querySelector('#oga26VariantId'); vid = h && h.value; }
        checkoutWith(vid, b);
      });
    });
  }

  /* ---------------- geri sayım ---------------- */
  function countdown() {
    var units = root.querySelector('[data-timer-units]');
    var txt = root.querySelector('[data-timer-text]');
    var sub = root.querySelector('[data-timer-subtext]');
    if (!units || !CFG.countdown) return;
    var KEY = 'olbiy_oga26_deadline', W = 864e5, deadline;
    try {
      var st = parseInt(localStorage.getItem(KEY), 10);
      if (!st || st < Date.now()) { st = Date.now() + W; localStorage.setItem(KEY, String(st)); }
      deadline = st;
    } catch (e) { deadline = Date.now() + W; }
    units.hidden = false;
    if (txt) txt.textContent = 'Kampanya bitişine';
    if (sub) sub.textContent = 'Bu avantaj sayaç bitene kadar geçerli';
    var d = units.querySelector('[data-days]'), h = units.querySelector('[data-hours]'),
        m = units.querySelector('[data-minutes]'), s = units.querySelector('[data-seconds]');
    function p(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var df = Math.max(0, deadline - Date.now());
      if (d) d.textContent = p(Math.floor(df / 864e5));
      if (h) h.textContent = p(Math.floor(df % 864e5 / 36e5));
      if (m) m.textContent = p(Math.floor(df % 36e5 / 6e4));
      if (s) s.textContent = p(Math.floor(df % 6e4 / 1e3));
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------------- stok çubuğu ---------------- */
  function stock() {
    var cap = Number(CFG.stockTotal), left = Number(CFG.stockLeft);
    var meter = root.querySelector('[data-stock-meter]');
    var txt = root.querySelector('[data-stock-text]');
    var sub = root.querySelector('[data-stock-subtext]');
    if (!meter || !cap || !left || left > cap) return;
    var pct = Math.max(4, Math.round(left / cap * 100));
    requestAnimationFrame(function () { meter.style.width = pct + '%'; });
    if (txt) txt.textContent = left + ' / ' + cap + ' adet kaldı';
    if (sub) sub.textContent = 'Kampanya stoğu sınırlıdır';
  }

  function init() { reveal(); faq(); smooth(); floats(); packages(); modal(); buy(); countdown(); stock(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ============================================================================
   GECE AĞACI — GÖRSEL KATMAN
   Yıldız alanı · kayan şeritler · ritüel satırı · otomatik video ·
   kademeli görünme · paralaks · hero galerisi.
   Hepsi .oga26 kökü altında; sepet/modal mantığına dokunmaz.
   ============================================================================ */
(function () {
  'use strict';
  var root = document.querySelector('.oga26');
  if (!root) return;
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---- hilal-yıldız alanı ---- */
  $$('[data-stars]').forEach(function (f) {
    var n = f.clientWidth > 900 ? 46 : 24, h = '';
    for (var i = 0; i < n; i++) {
      var sz = (Math.random() * 1.7 + 1.1).toFixed(1);
      h += '<i style="left:' + (Math.random() * 100).toFixed(2) + '%;top:' +
           (Math.random() * 100).toFixed(2) + '%;width:' + sz + 'px;height:' + sz +
           'px;animation-delay:' + (Math.random() * 6).toFixed(2) + 's"></i>';
    }
    f.innerHTML = h;
  });

  /* ---- sonsuz kayan şeritler ---- */
  $$('[data-mq]').forEach(function (t) {
    var g = t.firstElementChild;
    if (!g) return;
    var c = g.cloneNode(true);
    c.setAttribute('aria-hidden', 'true');
    t.appendChild(c);
  });

  /* ---- hero ritüel satırı ---- */
  var rlHost = root.querySelector('[data-ritline]');
  if (rlHost) {
    var rlItems = Array.prototype.slice.call(rlHost.querySelectorAll('li'));
    if (reduce) {
      rlItems.forEach(function (x) { x.classList.add('on'); });
    } else {
      var rk = 0;
      var rtick = function () {
        rlItems.forEach(function (x, i) { x.classList.toggle('on', i === rk); });
        rk = (rk + 1) % rlItems.length;
      };
      rtick();
      setInterval(rtick, 2200);
    }
  }

  /* ---- videolar: görünürken oynat, çıkınca durdur ---- */
  var vids = $$('video[data-autoplay]');
  vids.forEach(function (v) {
    v.muted = true; v.setAttribute('muted', '');
    v.setAttribute('playsinline', ''); v.playsInline = true;
    v.loop = true;
  });
  if ('IntersectionObserver' in window) {
    var vo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { vo.observe(v); });
  } else {
    vids.forEach(function (v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); });
  }

  /* ---- kademeli görünme ---- */
  var rvs = $$('.rv, .stg');
  if (!('IntersectionObserver' in window) || reduce) {
    rvs.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    rvs.forEach(function (el) { io.observe(el); });
  }

  /* ---- paralaks ---- */
  var px = $$('.split-media img').concat($$('.peak > img'));
  if (px.length && !reduce && window.matchMedia('(min-width:900px)').matches) {
    var ticking = false;
    var move = function () {
      px.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        el.style.transform = 'scale(1.1) translateY(' + (p * -26).toFixed(1) + 'px)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(move); }
    }, { passive: true });
    move();
  }

  /* ---- hero görsel/video galerisi ---- */
  var stage = root.querySelector('[data-stage]');
  if (stage) {
    $$('.hv-thumb').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.hv-thumb').forEach(function (o) { o.classList.remove('on'); });
        b.classList.add('on');
        var badge = stage.querySelector('.hv-badge');
        var vid = b.getAttribute('data-v'), img = b.getAttribute('data-i');
        var media = stage.querySelector('video, img');
        if (media) media.remove();
        var el;
        if (vid) {
          el = document.createElement('video');
          el.src = vid;
          el.poster = b.getAttribute('data-p') || '';
          el.muted = true; el.loop = true; el.setAttribute('muted', '');
          el.playsInline = true; el.setAttribute('playsinline', '');
          el.addEventListener('loadeddata', function () {
            var q = el.play(); if (q && q.catch) q.catch(function () {});
          });
        } else {
          el = document.createElement('img');
          el.src = img;
          el.alt = b.getAttribute('aria-label') || '';
        }
        stage.insertBefore(el, badge || null);
      });
    });
  }
})();
